import React, { useEffect, useState } from 'react';
import Loading from './Loading';
import EmptyState from './EmptyState';
import Pagination from './Pagination';

// pageSize: paginate `data` on the client (for lists the API returns in full)
const DataTable = ({ columns, data, isLoading, emptyMessage, pageSize }) => {
  const [page, setPage] = useState(1);

  const totalPages = pageSize && data ? Math.max(1, Math.ceil(data.length / pageSize)) : 1;

  // keep the page in range when filters/deletes shrink the data
  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [page, totalPages]);

  if (isLoading) {
    return <Loading />;
  }

  if (!data || data.length === 0) {
    return <EmptyState message={emptyMessage} />;
  }

  const rows = pageSize ? data.slice((page - 1) * pageSize, page * pageSize) : data;

  return (
    <>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th key={index} style={column.style}>
                  {column.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={row._id || rowIndex}>
                {columns.map((column, colIndex) => (
                  <td key={colIndex} style={column.style}>
                    {column.render ? column.render(row) : row[column.accessor]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {pageSize && (
        <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
      )}
    </>
  );
};

export default DataTable;
